(()=>{if(window.wvCartOptionsLoaded)return;window.wvCartOptionsLoaded=true;
document.addEventListener('click',async event=>{
const button=event.target.closest('[data-wv-warranty]');if(!button||button.disabled)return;
const drawer=button.closest('m-cart-drawer');const message=drawer.querySelector('[data-wv-option-error]');button.disabled=true;
const root=window.Shopify.routes.root;
try{
const responseCart=await fetch(root+'cart.js',{cache:'no-store'});if(!responseCart.ok)throw new Error();const cart=await responseCart.json();
const variant=Number(button.dataset.wvWarranty);const lines=cart.items.filter(item=>item.variant_id===variant);
let path,body;
if(lines.length){path='cart/update.js';body={updates:Object.fromEntries(lines.map(item=>[item.key,0]))};}
else{path='cart/add.js';body={items:[{id:variant,quantity:1}]};}
body.sections=['cart-drawer'];body.sections_url=location.pathname;
const response=await fetch(root+path,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
const data=await response.json();if(!response.ok)throw new Error(data.description||'Could not update this option. Please try again.');
drawer.renderContents(data);const refreshed=await fetch(root+'cart.js',{cache:'no-store'}).then(r=>r.json());drawer.updateCartCount(refreshed.item_count);
}catch(error){if(message)message.textContent=error.message||'Could not update this option. Please try again.';}
finally{button.disabled=false;}
});})();